<template>
  <div class="c-responsability-box">
    <b-checkbox v-model="newValue" @input="updateValue" class="check">
      {{ label }}
    </b-checkbox>
    <p v-if="hasError" class="check-error">
      {{ errorLabel }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default:
        'Declaro que revisei minha chave PIX e confirmo que está correta.',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorLabel: {
      type: String,
      default:
        'Para prosseguir é necessário confirmar que os dados foram revisados.',
    },
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
  },

  data() {
    return {
      newValue: this.value,
    }
  },

  methods: {
    updateValue() {
      // see https://br.vuejs.org/v2/guide/components-custom-events.html#Modificador-sync
      this.$emit('update:value', this.newValue)
    },
  },
}
</script>

<style lang="scss">
.c-responsability-box {
  .b-checkbox.checkbox input[type='checkbox'] + .check {
    border-color: $gray-7 !important;
    border-radius: 2px;
  }

  .b-checkbox.checkbox input[type='checkbox']:checked + .check {
    background-color: $gray-7 !important;
    border-color: $gray-7 !important;
  }

  .check {
    font-size: 14px;
    border-color: $neutral;
    line-height: 16.94px;
  }

  .check-error {
    color: $error;
    font-size: 12px;
    margin-left: 27px;
  }
}
</style>
